<div class="flex flex-col gap-6 rounded-xl border border-gray-200 bg-white p-6 filters-shadow">
  <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
    <div class="group relative">
      <label
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3"
        i18n="@@filterSubProductTitle">
        Sub-Product Title
      </label>
      <input
        type="text"
        [(ngModel)]="filters().subProductTitle"
        class="focus-border-primary w-full rounded-lg border border-gray-400 p-2.5 text-sm outline-none"
        [placeholder]="isArabic ? 'ابحث باسم الصنف...' : 'Search sub-products...'" />
    </div>

    <div class="group relative">
      <label
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3"
        i18n="@@filterStatus">
        Status
      </label>
      <select
        [(ngModel)]="filters().status"
        class="w-full rounded-[10px] border border-gray-400 bg-white px-4 py-2 text-[14px] outline-none">
        <option value="" i18n="@@all">All</option>
        <option value="active" i18n="@@activated">Active</option>
        <option value="inactive" i18n="@@deactivated">Inactive</option>
      </select>
    </div>

    <div class="group relative">
      <label
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3"
        i18n="@@filterCreatedFrom">
        Created From
      </label>
      <input
        type="date"
        [(ngModel)]="filters().createdOnFrom"
        class="w-full rounded-lg border border-gray-400 p-2.5 text-sm outline-none"
        [class.border-red-500]="isDateInvalid()" />
    </div>

    <div class="group relative">
      <label
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3"
        i18n="@@filterCreatedTo">
        Created To
      </label>
      <input
        type="date"
        [(ngModel)]="filters().createdOnTo"
        class="w-full rounded-lg border border-gray-400 p-2.5 text-sm outline-none" />
    </div>
  </div>

  @if (isDateInvalid()) {
    <p class="px-1 text-xs text-red-500" i18n="@@filterDateError">Created On From cannot be after Created On To</p>
  }

  <div class="flex items-center justify-between border-t border-gray-100 pt-4">
    <div class="flex gap-2">
      <select [(ngModel)]="filters().orderBy" class="rounded-lg border border-gray-400 px-4 py-2 text-sm outline-none">
        <option value="LAST_MODIFICATION_DATE" i18n="@@sortLastModified">Last Modified</option>
        <option value="CREATION_DATE" i18n="@@sortCreationDate">Creation Date</option>
        <option value="TITLE" i18n="@@sortTitle">Title</option>
      </select>
      <button
        (click)="onSortToggle.emit()"
        class="cursor-pointer rounded-lg border border-gray-400 px-4 py-2 text-xs font-bold uppercase transition-colors hover:bg-gray-50">
        @if (filters().orderDir === "ASC") {
          <span i18n="@@sortAsc">ASC</span>
        } @else {
          <span i18n="@@sortDesc">DESC</span>
        }
      </button>
    </div>

    <div class="flex gap-3">
      <button
        (click)="onReset.emit()"
        class="border-primary text-primary cursor-pointer rounded-lg border px-6 py-2 text-sm font-bold"
        i18n="@@filterResetBtn">
        Clear
      </button>
      <button
        (click)="onApply.emit()"
        [disabled]="isDateInvalid()"
        class="bg-primary cursor-pointer rounded-lg px-6 py-2 text-sm font-bold text-white disabled:opacity-50"
        i18n="@@filterApplyBtn">
        Apply
      </button>
    </div>
  </div>
</div>
